




































































import { Component, Vue } from 'vue-property-decorator';
import { IntegrationVm } from '../classes/integrationVm';
import { IntegrationApi } from '../api/integrations';
import PropSettings from 'modules/common/components/PropSettings.vue';
import { ContactProperty } from '../../installation-wizard/classes/contactProperty';
import { Integrations } from '../../installation-wizard/enums/integrations';
import appMessage from '../../core/models/appMessage';
import { IntegrationApiKeys } from '@/modules/installation-wizard/classes/integrationApiKeys';
import { ElForm } from 'node_modules/element-ui/types/form';
@Component({
  components: {
    PropSettings,
  },
})
export default class Integration extends Vue {
  public integrationId!: string;
  public loading: boolean = false;
  public integration: IntegrationVm = {
    id: '',
    type: Integrations.CUSTOM,
    status: '',
    name: '',
  };
  public props: ContactProperty[] = [];
  public integrationApiKeys: IntegrationApiKeys = new IntegrationApiKeys();
  public formRules: any = {};
  private api: IntegrationApi;

  constructor() {
    super();
    this.api = new IntegrationApi();
  }

  public async created() {
    if (this.$route.query.id) {
      this.integrationId = this.$route.query.id as string;
    } else {
      this.$router.push('/integrations');
    }

    await this.getIntegrationAndProperties();

    await this.getIntegrationApiKeys();

    this.createFormRules();
  }

  public createFormRules() {
    this.formRules = {
        url: [
            { required: this.isUrlVisible(), message: this.$t('forms.required'), trigger: 'blur' },
            {
                trigger: 'blur',
                validator: (rule: any, value: string, callback: (error?: Error) => void) => {
                    if (this.isUrlValid(value)) {
                        callback();
                    } else {
                        callback(new Error(this.$t('forms.wrongUrl') as string));
                    }
                },
            },
        ],
        apiKey: [
            { required: true, message: this.$t('forms.required'), trigger: 'blur' },
        ],
    };
  }

  public async getIntegrationAndProperties() {
    try {
      const data = await this.api.getIntegrationAndProps(this.integrationId);

      this.integration = data.integration;
    } catch (error) {
      this.$router.push('/integrations');
    }
  }

  public async getIntegrationApiKeys() {
    this.integrationApiKeys = await this.api.getIntegrationApiKeys(this.integration.type);
    this.integrationApiKeys.id = this.integration.id;
  }

  public goToIntegrations() {
    this.$router.push('/integrations');
  }

  public async validateForm() {
    return new Promise((resolve, reject) => {
        (this.$refs.form as ElForm).validate((isValid: boolean, invalidFields: object) => {
            resolve(isValid);
        });
    });
  }

  public async saveKeys() {
    if (await this.validateForm() === false) {
      return;
    }
    try {
      this.loading = true;
      await this.api.saveIntegrationApiKeys(this.integrationApiKeys);
      appMessage.show(this.$t('wizard.erecruiterAccessKeyUpdated'), "success")
    } catch (error) {
    }
    this.loading = false;
  }

  public isUrlVisible() {
    if (this.integration.type === Integrations.PRESTASHOP) {
        return true;
    }

    return false;
  }

  public isUrlValid(url: string): boolean {
      const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3})|' + // OR ip (v4) address
          '(localhost))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'); // port and path
      return !!pattern.test(url);
  }

  private canShowApiKeys(): boolean {
    if (this.integration.type === Integrations.BASELINKER) {
      return true;
    }

    if (this.integration.type === Integrations.PRESTASHOP) {
      return true;
    }
     if (this.integration.type === Integrations.ERECRUITER) {
      return true;
    }

    return false;
  }
  private canShowApiloStep(): boolean
  {
    return this.integration.type == Integrations.APILO;
  }

  private canShowAllegroLogin(): boolean {
    if (this.integration.type === Integrations.ALLEGRO && this.integration.status === 'expired') {
      return true;
    }

    return false;
  }

  private connectAllegro() {
    const getUrl = window.location;
    const url = getUrl .protocol + '//' + getUrl.host + '/allegro/api/v1.0/LoginToAllegro';
    window.open(url, '_blank');
  }
}
